var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{ 'is-iframe': _vm.isInIframe }},[_vm._m(0),_c('div',{staticClass:"center-user"},[_c('company')],1),_c('div',{staticClass:"right-container"},[_c('customer-service'),_c('notice'),_c('out')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-content"},[_c('img',{staticClass:"logo_img",attrs:{"src":require("@/assets/icons/logo3.png"),"alt":"泛亚人力"}})])
}]

export { render, staticRenderFns }